import { IStore } from '../../store';
import { jobSelectors } from '../../_core/job';
import { IORB4Store } from './@types';
import { EORB4Actions } from './actions';

const orb4Selectors = {
    _getStore(store: IStore) {
        return store.app.orb4;
    },
    getHistoryList(store: IORB4Store) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: IORB4Store) {
        return {
            ...store.filter,
            shownRecords: store.filter.shownRecords
                ? store.filter.shownRecords
                : 'ALL',
        };
    },
    jobToLoadHistory(store: IORB4Store) {
        return jobSelectors.getJobStatus(store, EORB4Actions.HISTORY_LOAD);
    },
};
export default orb4Selectors;
